import React, { useRef } from 'react';
import Logo from '../../assets/images/Logo-Filadelfia-Hitam.png';
import './Kartu.css';
import { toPng } from 'html-to-image';
import { saveAs } from 'file-saver';

function Kartu() {
  const user = JSON.parse(localStorage.getItem('user'));
  const kartuRef = useRef(null);

  const handleDownload = () => {
    if (kartuRef.current === null) return;

    toPng(kartuRef.current, { cacheBust: true })
      .then((dataUrl) => {
        saveAs(dataUrl, 'kartu-nama.png');
      })
      .catch((err) => {
        console.error('Failed to download image:', err);
      });
  };

  return (
    <div className="homepage kartupage">
      <div className="kartuNama" ref={kartuRef}>
        <div className="header_kartu">
          <div className="logo_kartu">
            <img src={Logo} alt="Logo"  />
          </div>
        </div>
        <div className="isi_kartu">
        <img src={`data:image/png;base64,${user.qr_base_64}`} alt="QR" />
          <p>{user?.nama}</p>
          {user?.hp}
        </div>
      </div>

      <div className="downloadKartu">
        <button className="downloadbtn" onClick={handleDownload}>
          Download Kartu
        </button>
      </div>
    </div>
  );
}

export default Kartu;
